/**
 * SightingBar - the GM's question when the opposition could see someone (plan map-display, H).
 *
 * "Gorm could see Vael (8 m, in the light). So could Grax." - one question per character, its nearest watcher
 * named first (2026-10-28): Roll it (Concealment against Awareness, a call for the test),
 * Seen (the ladder one rung up), Missed. The display never detects alone; this is a question, never a
 * verdict. Seen offers the move that follows (Z2): the watcher closing in, Move them or Leave them. One at a
 * time; how many more wait is said. Draws nothing when there is none - always, for a player.
 *
 * @param {object} props
 * @param {object} props.sightings - hooks/useStealthSightings
 */
import common from '../../styles/common.module.css';
import styles from '../../styles/CallForTest.module.css';

export default function SightingBar({ sightings }) {
  const s = sightings?.current;
  const proposal = sightings?.proposal;
  if (!s && !proposal) return null;
  return (
    <div className={styles.calls} role="status" data-testid="sighting-bar">
      {proposal && <CloseInProposal proposal={proposal} sightings={sightings} />}
      {s && <SightingLine s={s} sightings={sightings} />}
    </div>
  );
}

/**
 * The move that follows a sighting (Z2), for the GM alone: the watcher could close on the one it saw and stop in
 * reach - Move them, or Leave them. The display's ghost route shows where.
 */
function CloseInProposal({ proposal, sightings }) {
  return (
    <div className={styles.callLine} data-testid="close-in">
      <span>
        <b>PROPOSED · FOR THE GM</b> {proposal.mover} could close on {proposal.toward} and stop in reach,{' '}
        {proposal.metres.toFixed(1)} m.
      </span>
      <button type="button" className={common.btnDodge} data-testid="close-in-move" onClick={sightings.moveThem}>
        Move them
      </button>
      <button type="button" className={common.btnSmall} data-testid="close-in-leave" onClick={sightings.leaveThem}>
        Leave them
      </button>
    </div>
  );
}

/** One sighting: who could see whom, how far, in which light - and the GM's three answers. */
function SightingLine({ s, sightings }) {
  return (
    <>
      <div className={styles.callLine}>
        <span data-testid="sighting-line">
          {s.watcher} could see {s.target} ({s.distance} m, {s.lit ? 'in the light' : 'in the dark'}).
          {s.also?.length ? ` So could ${s.also.join(', ')}.` : ''}
          {s.more > 0 ? ` ${s.more} more waiting.` : ''}
        </span>
        <button type="button" className={common.btnDodge} data-testid="sighting-roll" onClick={sightings.rollIt}>
          Roll it
        </button>
        <button type="button" className={common.btnSmall} data-testid="sighting-seen" onClick={sightings.seen}>
          Seen
        </button>
        <button type="button" className={common.btnSmall} data-testid="sighting-missed" onClick={sightings.missed}>
          Missed
        </button>
      </div>
    </>
  );
}
